module.exports = __webpack_public_path__ + "static/img/profile-icon12.b39c9f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon12.png
// module id = 2960
// module chunks = 1